import _ from 'underscore';

export function formatRSAObject(adItem) {
  let adObject = _.pick(adItem, [
    'FinalUrls',
    'DisplayUrl',
    'MobileFinalUrls',
    'Path1',
    'Path2',
    'TrackingUrlTemplate',
    'FinalUrlSuffix',
  ]);

  adObject = _.extend(
    adObject,
    {
      '@odata.type': 'Model.ResponsiveSearchAd',
      Type: 'ResponsiveSearch',
      Headlines: _.map(
        _.filter(adItem.Headlines, h => !_.isEmpty(h.Asset.Text.trim())),
        h => ({
          Asset: {
            '@odata.type': '#Model.TextAsset',
            AssetType: 'Text',
            Name: null,
            Text: h.Asset.Text.trim(),
          },
          PinnedField: h.PinnedField,
        })
      ),
      Descriptions: _.map(
        _.filter(adItem.Descriptions, d => !_.isEmpty(d.Asset.Text.trim())),
        d => ({
          Asset: {
            '@odata.type': '#Model.TextAsset',
            AssetType: 'Text',
            Name: null,
            Text: d.Asset.Text.trim(),
          },
          PinnedField: d.PinnedField,
        })
      ),
      UrlCustomParameters: _.filter(adItem.UrlCustomParameters, ({ Key }) => !_.isEmpty(Key)),
    },
    adItem.Campaign ? {
      Campaign: { Id: adItem.Campaign.Id },
    } : {},
    adItem.AdGroup ? {
      AdGroup: { Id: adItem.AdGroup.Id },
    } : {},
    _.first(adItem.MobileFinalUrls) === 'https://' || _.first(adItem.MobileFinalUrls) === 'http://' ? {
      MobileFinalUrls: [],
    } : {}
  );

  return adObject;
}

function formatAssetRankingTexts(assetValues) {
  const textArr = _.map(assetValues, item => item && item.Asset && item.Asset.Text);

  return _.uniq(_.compact(textArr));
}

export function formatRankingTexts(assets) {
  return _.mapObject(
    assets,
    assetValues => formatAssetRankingTexts(assetValues)
  );
}

export function computeRankingTextsUpdates(currentAssets, prevAssetsRankingTexts) {
  const rankingTexts = formatRankingTexts(currentAssets);

  return {
    needUpdate: !_.isEqual(rankingTexts, prevAssetsRankingTexts),
    value: rankingTexts,
  };
}
